/**
 * Type from '@googlemaps/google-maps-services-js' named PlaceType2.
 * Extracted to avoid importing whole library.
 */
export enum PlaceType {
  AdministrativeAreaLevel1 = 'administrative_area_level_1',
  AdministrativeAreaLevel2 = 'administrative_area_level_2',
  AdministrativeAreaLevel3 = 'administrative_area_level_3',
  AdministrativeAreaLevel4 = 'administrative_area_level_4',
  AdministrativeAreaLevel5 = 'administrative_area_level_5',
  Archipelago = 'archipelago',
  ColloquialArea = 'colloquial_area',
  Continent = 'continent',
  Country = 'country',
  Establishment = 'establishment',
  Finance = 'finance',
  Floor = 'floor',
  Food = 'food',
  GeneralContractor = 'general_contractor',
  Geocode = 'geocode',
  Health = 'health',
  Intersection = 'intersection',
  Landmark = 'landmark',
  Locality = 'locality',
  NaturalFeature = 'natural_feature',
  Neighborhood = 'neighborhood',
  PlaceOfWorship = 'place_of_worship',
  PlusCode = 'plus_code',
  PointOfInterest = 'point_of_interest',
  Political = 'political',
  PostBox = 'post_box',
  PostalCode = 'postal_code',
  PostalCodePrefix = 'postal_code_prefix',
  PostalCodeSuffix = 'postal_code_suffix',
  PostalTown = 'postal_town',
  Premise = 'premise',
  Room = 'room',
  Route = 'route',
  StreetAddress = 'street_address',
  StreetNumber = 'street_number',
  Sublocality = 'sublocality',
  SublocalityLevel1 = 'sublocality_level_1',
  SublocalityLevel2 = 'sublocality_level_2',
  SublocalityLevel3 = 'sublocality_level_3',
  SublocalityLevel4 = 'sublocality_level_4',
  SublocalityLevel5 = 'sublocality_level_5',
  Subpremise = 'subpremise',
  TownSquare = 'town_square',
}
